import { render, staticRenderFns } from "./ApplicationFieldHeading.vue?vue&type=template&id=8c37d2de&scoped=true&"
import script from "./ApplicationFieldHeading.vue?vue&type=script&lang=js&"
export * from "./ApplicationFieldHeading.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationFieldHeading.vue?vue&type=style&index=0&id=8c37d2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c37d2de",
  null
  
)

export default component.exports